import { render } from "./BDAExtraction.vue?vue&type=template&id=3ea83878&scoped=true"
import script from "./BDAExtraction.vue?vue&type=script&lang=js"
export * from "./BDAExtraction.vue?vue&type=script&lang=js"

import "./BDAExtraction.vue?vue&type=style&index=0&id=3ea83878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea83878"]])

export default __exports__